import { useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageContent from "./PageContent";

function ErrorComponent() {
  const error = useRouteError();
  const [t] = useTranslation();

  let title = t("error-page.an-error-occurred");
  let message = t("error-page.something-went-wrong");
  console.log("error message", error);
  if (error?.status === 500) {
    message = error.data?.message || message;
  }

  if (error?.status === 404) {
    title = t("error-page.not-found");
    message = t("error-page.could-not-find");
  }

  return (
    <PageContent title={title}>
      <p>{message}</p>
    </PageContent>
  );
}

export default ErrorComponent;
